import React from "react";
import "antd/dist/antd.css";
import { Select } from "antd";
import { Container, Row } from "react-bootstrap";
const { Option } = Select;

const CategoryFilters = () => {
  const handleChange = (value) => {
    //console.log(`selected ${value}`);
  };
  return (
    <div>
      <div style={{ fontSize: "1.4rem" }}>
        <b>SELECT CATEGORY</b>
      </div>
      <Select
        showSearch
        style={{
          width: 200,
        }}
        placeholder="Search to Select"
        optionFilterProp="children"
        filterOption={(input, option) => option.children.includes(input)}
        filterSort={(optionA, optionB) =>
          optionA.children
            .toLowerCase()
            .localeCompare(optionB.children.toLowerCase())
        }
      >
        <Option value="1">Not Identified</Option>
        <Option value="2">Closed</Option>
        <Option value="3">Communicated</Option>
        <Option value="4">Identified</Option>
        <Option value="5">Resolved</Option>
        <Option value="6">Cancelled</Option>
      </Select>
    </div>
  );
};

export default CategoryFilters;
